import React, { useState, useRef, useCallback, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Sidebar from '../components/Sidebar';
import apiClient from '../utils/apiConfig';
import * as pdfjsLib from 'pdfjs-dist';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';

pdfjsLib.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjsLib.version}/pdf.worker.min.js`;

const limpiarTexto = (t) =>
  t.normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-zA-Z0-9\s\-_().@]/g, '');
const limpiarNumero = (t) => t.replace(/[^0-9]/g, '');

const COLORES_FIRMANTES = [
  { bg: '#e3f2fd', border: '#1976d2', text: '#1565c0' },
  { bg: '#e8f5e9', border: '#388e3c', text: '#2e7d32' },
  { bg: '#fff3e0', border: '#f57c00', text: '#e65100' },
  { bg: '#f3e5f5', border: '#7b1fa2', text: '#6a1b9a' },
  { bg: '#fce4ec', border: '#c62828', text: '#b71c1c' },
  { bg: '#e0f7fa', border: '#00838f', text: '#006064' },
  { bg: '#fff8e1', border: '#f9a825', text: '#f57f17' },
  { bg: '#efebe9', border: '#5d4037', text: '#4e342e' },
];
const obtenerColor = (i) => COLORES_FIRMANTES[i % COLORES_FIRMANTES.length];

const Toast = ({ toast, onClose }) => {
  if (!toast) return null;
  return (
    <div style={{
      position: 'fixed', bottom: 24, right: 24, zIndex: 9999,
      backgroundColor: '#dc3545', color: 'white',
      padding: '14px 20px', borderRadius: 10,
      boxShadow: '0 4px 20px rgba(0,0,0,0.25)',
      display: 'flex', alignItems: 'center', gap: 12,
      animation: 'slideIn 0.3s ease', maxWidth: 360
    }}>
      <i className="bi bi-exclamation-triangle-fill" style={{ fontSize: '1.3rem' }}></i>
      <span style={{ fontSize: '0.9rem' }}>{toast}</span>
      <button onClick={onClose} style={{ background: 'none', border: 'none', color: 'white', marginLeft: 'auto', cursor: 'pointer', fontSize: '1.1rem' }}>×</button>
      <style>{`@keyframes slideIn { from { transform: translateX(100%); opacity: 0; } to { transform: translateX(0); opacity: 1; } }`}</style>
    </div>
  );
};

const PDF_W = 612;
const PDF_H = 792;

function AdminSendDocumentPage() {
  const navigate = useNavigate();
  const [sidebarAbierto, setSidebarAbierto] = useState(true);
  const [paso, setPaso] = useState(1);
  const [errors, setErrors] = useState({});
  const [mensaje, setMensaje] = useState('');
  const [enviando, setEnviando] = useState(false);
  const [omitirCerticamara, setOmitirCerticamara] = useState(false);
  const [processingMessage, setProcessingMessage] = useState('');
  const [toast, setToast] = useState('');

  // PASO 1
  const [documento, setDocumento] = useState(null);
  const [nombreDocumento, setNombreDocumento] = useState('');
  const [descripcionDocumento, setDescripcionDocumento] = useState('');

  // PASO 2
  const [firmantes, setFirmantes] = useState([{
    id: 1, nombre: '', cedula: '', correo: '', celular: '',
    tipoFirmante: 'externo', metodoEnvio: [], buscando: false
  }]);
  const [contadorId, setContadorId] = useState(2);
  const dragIndex = useRef(null);
  const dragOverIndex = useRef(null);

  // PASO 3
  const [ordenFirma, setOrdenFirma] = useState('paralelo');
  const [tieneCaducidad, setTieneCaducidad] = useState(false);
  const [diasCaducidad, setDiasCaducidad] = useState('');
  const [fechaCaducidad, setFechaCaducidad] = useState('');
  const [requiereOtp, setRequiereOtp] = useState(true);
const [requiereFoto, setRequiereFoto] = useState(true);
const [requiereGrafo, setRequiereGrafo] = useState(true);


  // PASO 4
  const [pdfDoc, setPdfDoc] = useState(null);
  const [pdfRealW, setPdfRealW] = useState(PDF_W);
  const [pdfRealH, setPdfRealH] = useState(PDF_H);
  const [paginaActual, setPaginaActual] = useState(0);
  const [totalPaginas, setTotalPaginas] = useState(1);
  const [scale, setScale] = useState(1.2);
  const [loadingPdf, setLoadingPdf] = useState(false);
  const [elementos, setElementos] = useState([
    { id: 'firma-1', tipo: 'firma', x: 350, y: 80, w: 170, h: 60, pagina: 0, label: '' }
  ]);
  const [elementoSeleccionado, setElementoSeleccionado] = useState('firma-1');
  const [herramienta, setHerramienta] = useState('mover');
  const [textoInput, setTextoInput] = useState('');
  const [mostrarInputTexto, setMostrarInputTexto] = useState(false);
  const canvasRef = useRef(null);
  // ⭐ Ref al div wrapper (position:relative) donde viven los elementos
  const wrapperRef = useRef(null);
  const renderTaskRef = useRef(null);
  const isRenderingRef = useRef(false);
  const interRef = useRef(null);

  const esUnFirmante = firmantes.length === 1;

  const pasos = esUnFirmante
    ? [
        { num: 1, label: 'Documento', icon: 'bi-file-earmark-pdf' },
        { num: 2, label: 'Firmante',  icon: 'bi-person-check' },
        { num: 3, label: 'Opciones',  icon: 'bi-sliders' },
        { num: 4, label: 'Posición',  icon: 'bi-pencil-square' },
        { num: 5, label: 'Enviar',    icon: 'bi-send-check' },
      ]
    : [
        { num: 1, label: 'Documento', icon: 'bi-file-earmark-pdf' },
        { num: 2, label: 'Firmantes', icon: 'bi-people' },
        { num: 3, label: 'Opciones',  icon: 'bi-sliders' },
        { num: 4, label: 'Confirmar', icon: 'bi-send-check' },
      ];

  const totalPasos = pasos.length;

  useEffect(() => {
    if (paso === 4 && esUnFirmante && documento && !pdfDoc) cargarPdfLocal();
  }, [paso]);

  const cargarPdfLocal = async () => {
    if (!documento) return;
    setLoadingPdf(true);
    try {
      const ab = await documento.arrayBuffer();
      const pdf = await pdfjsLib.getDocument({ data: ab }).promise;
      setPdfDoc(pdf);
      setTotalPaginas(pdf.numPages);
      setElementos(prev => prev.map(el =>
        el.tipo === 'firma' ? { ...el, label: firmantes[0]?.nombre?.split(' ')[0] || 'Firmante' } : el
      ));
    } catch (err) { console.error('Error PDF:', err); }
    finally { setLoadingPdf(false); }
  };

  useEffect(() => {
    if (pdfDoc && canvasRef.current) renderPagina();
  }, [pdfDoc, paginaActual, scale]);

  const renderPagina = async () => {
    if (!pdfDoc || !canvasRef.current || isRenderingRef.current) return;
    if (renderTaskRef.current) { try { await renderTaskRef.current.cancel(); } catch {} renderTaskRef.current = null; }
    isRenderingRef.current = true;
    try {
      const page = await pdfDoc.getPage(paginaActual + 1);
      const viewport = page.getViewport({ scale });
      const canvas = canvasRef.current;
      canvas.width = viewport.width;
      canvas.height = viewport.height;

      // ⭐ SPRINT 4: capturar el tamaño REAL del PDF (escala 1 = puntos PDF).
      // viewport con scale=1 nos da el ancho/alto reales en puntos.
      const vpReal = page.getViewport({ scale: 1 });
      setPdfRealW(vpReal.width);
      setPdfRealH(vpReal.height);
      const rt = page.render({ canvasContext: canvas.getContext('2d'), viewport });
      renderTaskRef.current = rt;
      await rt.promise;
    } catch (e) { if (e.name !== 'RenderingCancelledException') console.error(e); }
    finally { isRenderingRef.current = false; }
  };

  // Coordenadas PDF → visuales
  // ⭐ SPRINT 4: usa la altura REAL del PDF (pdfRealH) en vez de 792 fijo.
  const elVisual = useCallback((el) => ({
    left:   el.x * scale,
    top:    (pdfRealH - el.y - el.h) * scale,
    width:  el.w * scale,
    height: el.h * scale,
  }), [scale, pdfRealH]);

  // Click en canvas para colocar elemento nuevo
  const handleCanvasClick = useCallback((e) => {
    if (herramienta === 'mover' || !wrapperRef.current) return;
    const rect = wrapperRef.current.getBoundingClientRect();
    const vL = e.clientX - rect.left;
    const vT = e.clientY - rect.top;
    const pdfX = Math.round(vL / scale);
    // ⭐ SPRINT 4: altura real del PDF
    const pdfY = Math.round(pdfRealH - (vT / scale));
    const defSizes = { firma: [170,60], fecha: [140,30], texto: [130,28], casilla: [24,24] };
    const [w, h] = defSizes[herramienta] || [140, 30];
    const label = herramienta === 'fecha'
  ? new Date().toLocaleDateString('es-CO', { day:'2-digit', month:'long', year:'numeric' })
  : herramienta === 'texto' ? 'Texto'
  : herramienta === 'firma' ? (firmantes[0]?.nombre?.split(' ')[0] || 'Firma')
  : '';
    const newEl = {
      id: `${herramienta}-${Date.now()}`, tipo: herramienta,
      x: Math.max(0, pdfX - Math.round(w/2)),
      y: Math.max(0, pdfY - Math.round(h/2)),
      w, h, pagina: paginaActual, label
    };
    setElementos(prev => [...prev, newEl]);
    setElementoSeleccionado(newEl.id);
    setHerramienta('mover');
  }, [herramienta, scale, paginaActual, pdfRealH]);

  // ⭐ MouseDown — guarda wrapperRect en el momento del click
  const handleElMouseDown = useCallback((e, id) => {
    e.preventDefault(); e.stopPropagation();
    setElementoSeleccionado(id);
    const el = elementos.find(x => x.id === id);
    if (!el || !wrapperRef.current) return;

    // Rect del wrapper (el div position:relative que contiene los elementos)
    // Este es el sistema de coordenadas correcto — no cambia con scroll
    const wrapperRect = wrapperRef.current.getBoundingClientRect();
    const elRect = e.currentTarget.getBoundingClientRect();

    interRef.current = {
      tipo: 'drag', id,
      // Offset: distancia desde el borde del elemento hasta donde hiciste clic
      offsetX: e.clientX - elRect.left,
      offsetY: e.clientY - elRect.top,
      // Guardar wrapperRect en el momento del click (referencia fija)
      wrapperRect: { left: wrapperRect.left, top: wrapperRect.top },
      startEl: { ...el }
    };
  }, [elementos]);

  // MouseDown en esquina → resize
  const handleCornerMouseDown = useCallback((e, id, corner) => {
    e.preventDefault(); e.stopPropagation();
    const el = elementos.find(x => x.id === id);
    if (!el) return;
    interRef.current = {
      tipo: 'resize', id, corner,
      startMouseX: e.clientX, startMouseY: e.clientY,
      startEl: { ...el }
    };
  }, [elementos]);

  // ⭐ MouseMove — usa wrapperRect guardado en mousedown
  const handleMouseMovePdf = useCallback((e) => {
    const inter = interRef.current;
    if (!inter) return;

    if (inter.tipo === 'drag') {
      const { wrapperRect, offsetX, offsetY, startEl } = inter;

      // Posición del top-left del elemento en coordenadas del wrapper
      let vL = e.clientX - wrapperRect.left - offsetX;
      let vT = e.clientY - wrapperRect.top  - offsetY;

      // Limitar dentro del wrapper (= canvas)
      // ⭐ SPRINT 4: usar dimensiones reales del PDF
      const canvasW = pdfRealW * scale;
      const canvasH = pdfRealH * scale;
      vL = Math.max(0, Math.min(vL, canvasW - startEl.w * scale));
      vT = Math.max(0, Math.min(vT, canvasH - startEl.h * scale));

      // Convertir visual → PDF (Y invertido)
      const newX = Math.round(vL / scale);
      const newY = Math.round(pdfRealH - (vT / scale) - startEl.h);

      setElementos(prev => prev.map(el =>
        el.id === inter.id ? { ...el, x: newX, y: newY, pagina: paginaActual } : el
      ));
    }

    if (inter.tipo === 'resize') {
      const dx = (e.clientX - inter.startMouseX) / scale;
      const dy = (e.clientY - inter.startMouseY) / scale;
      const { corner, startEl } = inter;
      const MIN = 24;
      let { x, y, w, h } = startEl;

      if (corner === 'se') { w = Math.max(MIN, startEl.w + dx); h = Math.max(MIN, startEl.h + dy); }
      if (corner === 'sw') { w = Math.max(MIN, startEl.w - dx); x = startEl.x + (startEl.w - w); h = Math.max(MIN, startEl.h + dy); }
      if (corner === 'ne') { w = Math.max(MIN, startEl.w + dx); h = Math.max(MIN, startEl.h - dy); y = startEl.y + (startEl.h - h); }
      if (corner === 'nw') { w = Math.max(MIN, startEl.w - dx); x = startEl.x + (startEl.w - w); h = Math.max(MIN, startEl.h - dy); y = startEl.y + (startEl.h - h); }

      setElementos(prev => prev.map(el =>
        el.id === inter.id
          ? { ...el, x: Math.round(x), y: Math.round(y), w: Math.round(w), h: Math.round(h) }
          : el
      ));
    }
  }, [scale, paginaActual, pdfRealW, pdfRealH]);

  const handleMouseUpPdf = useCallback(() => { interRef.current = null; }, []);

  const eliminarElemento = (id) => {
    setElementos(prev => prev.filter(el => el.id !== id));
    if (elementoSeleccionado === id) setElementoSeleccionado(null);
  };

  const agregarTexto = () => {
    if (!textoInput.trim()) return;
    const newEl = { id: `texto-${Date.now()}`, tipo: 'texto', x: 72, y: 350, w: 150, h: 28, pagina: paginaActual, label: textoInput.trim() };
    setElementos(prev => [...prev, newEl]);
    setElementoSeleccionado(newEl.id);
    setTextoInput('');
    setMostrarInputTexto(false);
  };

  const mostrarToast = (msg) => { setToast(msg); setTimeout(() => setToast(''), 4000); };

  // Firmantes
  const agregarFirmante = () => {
    setFirmantes(prev => [...prev, { id: contadorId, nombre: '', cedula: '', correo: '', celular: '', tipoFirmante: 'externo', metodoEnvio: [], buscando: false }]);
    setContadorId(p => p + 1);
  };
  const eliminarFirmante = (id) => { if (firmantes.length <= 1) return; setFirmantes(prev => prev.filter(f => f.id !== id)); };
  const actualizarFirmante = (id, campo, valor) => setFirmantes(prev => prev.map(f => f.id === id ? { ...f, [campo]: valor } : f));
  const toggleMetodo = (id, metodo) => setFirmantes(prev => prev.map(f => {
    if (f.id !== id) return f;
    const m = f.metodoEnvio.includes(metodo) ? f.metodoEnvio.filter(x => x !== metodo) : [...f.metodoEnvio, metodo];
    return { ...f, metodoEnvio: m };
  }));

  const handleDragStart = (index) => { dragIndex.current = index; };
  const handleDragOver = (e, index) => { e.preventDefault(); dragOverIndex.current = index; };
  const handleDrop = () => {
    if (dragIndex.current === null || dragIndex.current === dragOverIndex.current) return;
    const arr = [...firmantes];
    const [moved] = arr.splice(dragIndex.current, 1);
    arr.splice(dragOverIndex.current, 0, moved);
    setFirmantes(arr);
    dragIndex.current = null; dragOverIndex.current = null;
  };

  const buscarPersona = async (id, cedula) => {
    if (!cedula) return;
    actualizarFirmante(id, 'buscando', true);
    try {
      const res = await apiClient.get(`/api/buscar-persona/${cedula}`);
      const d = res.data?.data;
      if (d) {
        setFirmantes(prev => prev.map(f => f.id !== id ? f : { ...f, nombre: d.nombres || '', correo: d.correo || '', celular: d.celular || '', tipoFirmante: res.data.tipo || 'externo', buscando: false }));
        setMensaje(`✅ Encontrado: ${d.nombres}`);
      } else { mostrarToast('⚠️ No encontrado. Ingresa los datos manualmente.'); actualizarFirmante(id, 'buscando', false); }
    } catch { mostrarToast('⚠️ No encontrado. Ingresa los datos manualmente.'); actualizarFirmante(id, 'buscando', false); }
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    if (file.type !== 'application/pdf') { setErrors(p => ({ ...p, documento: 'Solo se permiten archivos PDF.' })); return; }
    setDocumento(file);
    setErrors(p => ({ ...p, documento: '' }));
    if (!nombreDocumento) {
      const nombre = file.name.replace(/\.pdf$/i, '').replace(/[-_]/g, ' ').toUpperCase().trim();
      setNombreDocumento(limpiarTexto(nombre));
    }
  };

  const validarPaso = (p) => {
    const errs = {};
    if (p === 1) {
      if (!documento) errs.documento = 'Debes subir un archivo PDF.';
      if (!nombreDocumento.trim()) errs.nombreDocumento = 'El nombre es obligatorio.';
    }
    if (p === 2) {
      const ef = [];
      let primerSinMetodo = null;
      firmantes.forEach((f, i) => {
        const e = {};
        if (!f.nombre.trim()) e.nombre = 'Obligatorio';
        if (!f.cedula.trim()) e.cedula = 'Obligatoria';
        if (!f.correo.trim() && !f.celular.trim()) e.contacto = 'Necesitas correo o celular';
        if (f.correo && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(f.correo)) e.correo = 'Correo inválido';
        if (f.celular && !/^\d{10}$/.test(f.celular)) e.celular = '10 dígitos';
        if (f.metodoEnvio.length === 0) { e.metodoEnvio = 'Selecciona al menos uno'; if (primerSinMetodo === null) primerSinMetodo = i + 1; }
        if (Object.keys(e).length) ef[i] = e;
      });
      if (primerSinMetodo !== null) mostrarToast(`⚠️ Faltan métodos de envío en el firmante #${primerSinMetodo}`);
      const cedulas = firmantes.map(f => f.cedula).filter(Boolean);
      const dups = cedulas.filter((c, i) => cedulas.indexOf(c) !== i);
      if (dups.length) errs.duplicados = `Cédulas duplicadas: ${[...new Set(dups)].join(', ')}`;
      if (ef.length) errs.firmantes = ef;
    }
    if (p === 3 && tieneCaducidad) {
      if (!diasCaducidad && !fechaCaducidad) errs.caducidad = 'Ingresa días o fecha de caducidad.';
    }
    setErrors(errs);
    return Object.keys(errs).length === 0;
  };

  const avanzar = () => { if (validarPaso(paso)) { setPaso(p => p + 1); setMensaje(''); setErrors({}); } };
  const retroceder = () => { setPaso(p => p - 1); setMensaje(''); setErrors({}); };

  const fechaMinima = new Date();
  fechaMinima.setDate(fechaMinima.getDate() + 1);
  const fechaMinimaStr = fechaMinima.toISOString().split('T')[0];

  const handleSubmit = async () => {
    setEnviando(true);
    setProcessingMessage('📤 Preparando envío...');
    try {
      const fd = new FormData();
      fd.append('documento', documento);
      fd.append('nombreDocumento', nombreDocumento);
      fd.append('descripcion', descripcionDocumento);
      fd.append('ordenFirma', esUnFirmante ? 'secuencial' : ordenFirma);
      fd.append('tipo', 'administrativo');
      fd.append('omitirCerticamara', omitirCerticamara ? 'true' : 'false');
      if (tieneCaducidad) {
        if (diasCaducidad) fd.append('diasCaducidad', diasCaducidad);
        else if (fechaCaducidad) fd.append('fechaCaducidad', fechaCaducidad);
      }
      if (esUnFirmante) {
  // ⭐ V5.8: Enviar TODAS las firmas como array
  const firmaEls = elementos.filter(e => e.tipo === 'firma');
  if (firmaEls.length > 0) {
    // Compatibilidad: firmaConfig sigue siendo la primera
    fd.append('firmaConfig', JSON.stringify({
      pagina: firmaEls[0].pagina,
      x: firmaEls[0].x,
      y: firmaEls[0].y,
      ancho: firmaEls[0].w,
      alto: firmaEls[0].h
    }));
    // ⭐ Array completo con todas las posiciones
    fd.append('firmasConfig', JSON.stringify(
      firmaEls.map(el => ({
        pagina: el.pagina,
        x: el.x,
        y: el.y,
        ancho: el.w,
        alto: el.h,
        label: el.label || ''
      }))
    ));
  }
  const extras = elementos.filter(e => e.tipo !== 'firma');
  if (extras.length > 0) fd.append('elementosExtra', JSON.stringify(extras));
}
      fd.append('requiereOtp',   requiereOtp  ? 'true' : 'false');
fd.append('requiereFoto',  requiereFoto ? 'true' : 'false');
fd.append('requiereGrafo', esUnFirmante ? (requiereGrafo ? 'true' : 'false') : 'false');
      fd.append('firmantes', JSON.stringify(
        firmantes.map((f, i) => ({
          orden: i + 1, nombre: f.nombre, cedula: f.cedula,
          correo: f.correo, celular: f.celular,
          tipoFirmante: f.tipoFirmante, metodoEnvio: f.metodoEnvio
        }))
      ));
      setProcessingMessage('📤 Enviando documento...');
      const res = await apiClient.post('/api/send-admin-document', fd, {
        headers: { 'Content-Type': 'multipart/form-data' },
        timeout: 120000
      });
      setProcessingMessage('✅ ¡Documento enviado!');
      setMensaje(`✅ ${res.data.message || 'Documento enviado exitosamente'}`);
      setTimeout(() => navigate('/administrative-documents'), 2000);
    } catch (error) {
      setMensaje(`❌ ${error.response?.data?.message || 'Error al enviar el documento.'}`);
    } finally { setEnviando(false); setProcessingMessage(''); }
  };

  return (
    <div
      className="d-flex"
      onMouseMove={paso === 4 && esUnFirmante ? handleMouseMovePdf : undefined}
      onMouseUp={paso === 4 && esUnFirmante ? handleMouseUpPdf : undefined}
      onMouseLeave={paso === 4 && esUnFirmante ? handleMouseUpPdf : undefined}
    >
      <Toast toast={toast} onClose={() => setToast('')} />
      <Sidebar onToggle={setSidebarAbierto} />
      <div className="flex-grow-1" style={{ marginLeft: sidebarAbierto ? '250px' : '70px', transition: 'margin-left 0.3s', padding: '24px 32px', minHeight: '100vh', backgroundColor: '#f0f4f8' }}>

        {/* HEADER */}
        <div className="d-flex align-items-center justify-content-between mb-4">
          <div>
            <h2 className="mb-1 fw-bold" style={{ color: '#1a1e4b' }}>📋 Enviar Documento Administrativo</h2>
            <p className="text-muted mb-0 small">Contratos, actas y documentos con múltiples firmantes</p>
          </div>
          <button className="btn btn-outline-secondary btn-sm" onClick={() => navigate('/administrative-documents')}>← Volver</button>
        </div>

        {/* INDICADOR DE PASOS */}
        <div className="card shadow-sm border-0 mb-4" style={{ borderRadius: 12 }}>
          <div className="card-body py-3 px-4">
            <div className="d-flex align-items-center">
              {pasos.map((p, i) => (
                <React.Fragment key={p.num}>
                  <div className="d-flex flex-column align-items-center" style={{ minWidth: 70 }}>
                    <div className="rounded-circle d-flex align-items-center justify-content-center mb-1"
                      style={{ width: 40, height: 40, backgroundColor: paso > p.num ? '#198754' : paso === p.num ? '#1a1e4b' : '#e9ecef', color: paso >= p.num ? 'white' : '#6c757d', transition: 'all 0.3s', fontWeight: 700 }}>
                      {paso > p.num ? <i className="bi bi-check-lg"></i> : <i className={`bi ${p.icon}`} style={{ fontSize: '1rem' }}></i>}
                    </div>
                    <small className="fw-semibold" style={{ fontSize: '0.7rem', color: paso === p.num ? '#1a1e4b' : paso > p.num ? '#198754' : '#adb5bd' }}>{p.label}</small>
                  </div>
                  {i < pasos.length - 1 && (
                    <div className="flex-grow-1 mx-1 mb-4" style={{ height: 3, backgroundColor: paso > p.num ? '#198754' : '#dee2e6', transition: 'background-color 0.3s', borderRadius: 4 }} />
                  )}
                </React.Fragment>
              ))}
            </div>
          </div>
        </div>

        {/* MENSAJES */}
        {mensaje && (
          <div className={`alert alert-dismissible mb-3 ${mensaje.startsWith('✅') ? 'alert-success' : mensaje.startsWith('❌') ? 'alert-danger' : 'alert-warning'}`}>
            {mensaje}
            <button className="btn-close" onClick={() => setMensaje('')}></button>
          </div>
        )}

        {/* PASO 1 */}
        {paso === 1 && (
          <div className="card shadow-sm border-0" style={{ borderRadius: 12 }}>
            <div className="card-body p-4">
              <h5 className="fw-bold mb-4" style={{ color: '#1a1e4b' }}><i className="bi bi-file-earmark-pdf me-2 text-danger"></i>Documento a Firmar</h5>
              <div
                className={`border rounded-3 p-5 text-center mb-4 ${documento ? 'border-success bg-success bg-opacity-10' : ''}`}
                style={{ borderStyle: documento ? 'solid' : 'dashed', borderWidth: 2, cursor: 'pointer', backgroundColor: documento ? undefined : '#fafbfc' }}
                onClick={() => document.getElementById('fileInput').click()}
                onDragOver={e => e.preventDefault()}
                onDrop={e => { e.preventDefault(); const f = e.dataTransfer.files[0]; if (f) handleFileChange({ target: { files: [f] } }); }}
              >
                {documento ? (
                  <><i className="bi bi-file-earmark-check-fill text-success" style={{ fontSize: '3rem' }}></i><h5 className="mt-2 text-success fw-bold">{documento.name}</h5><small className="text-muted">{(documento.size/1024/1024).toFixed(2)} MB · Clic para cambiar</small></>
                ) : (
                  <><div style={{ fontSize: '3rem' }}>📎</div><h5 className="mt-2 text-muted">Arrastra el PDF aquí o haz clic</h5><small className="text-muted">Solo archivos PDF · Máximo 100 MB</small></>
                )}
              </div>
              <input id="fileInput" type="file" accept=".pdf" onChange={handleFileChange} className="d-none" />
              {errors.documento && <div className="text-danger small mb-3">{errors.documento}</div>}
              <div className="row g-3">
                <div className="col-md-6">
                  <label className="form-label fw-semibold small">Nombre del documento *</label>
                  <input type="text" value={nombreDocumento} onChange={e => { setNombreDocumento(limpiarTexto(e.target.value).toUpperCase()); setErrors(p => ({ ...p, nombreDocumento: '' })); }} className={`form-control ${errors.nombreDocumento ? 'is-invalid' : ''}`} placeholder="Ej: CONTRATO DE PRESTACION DE SERVICIOS" />
                  {errors.nombreDocumento && <div className="invalid-feedback">{errors.nombreDocumento}</div>}
                </div>
                <div className="col-md-6">
                  <label className="form-label fw-semibold small">Descripción (opcional)</label>
                  <input type="text" value={descripcionDocumento} onChange={e => setDescripcionDocumento(e.target.value)} className="form-control" placeholder="Ej: Contrato para proveedor de insumos" />
                </div>
              </div>
              <div className="d-flex justify-content-end mt-4">
                <button className="btn btn-primary px-5" style={{ backgroundColor: '#1a1e4b', borderColor: '#1a1e4b' }} onClick={avanzar}>Siguiente <i className="bi bi-arrow-right ms-1"></i></button>
              </div>
            </div>
          </div>
        )}

        {/* PASO 2 */}
        {paso === 2 && (
          <div className="card shadow-sm border-0" style={{ borderRadius: 12 }}>
            <div className="card-body p-4">
              <div className="d-flex align-items-center justify-content-between mb-4">
                <h5 className="fw-bold mb-0" style={{ color: '#1a1e4b' }}><i className="bi bi-people me-2"></i>Firmantes<span className="badge ms-2" style={{ backgroundColor: '#1a1e4b' }}>{firmantes.length}</span></h5>
                <button className="btn btn-outline-success btn-sm" onClick={agregarFirmante}><i className="bi bi-person-plus me-1"></i> Agregar Firmante</button>
              </div>
              {errors.duplicados && <div className="alert alert-danger py-2 small">{errors.duplicados}</div>}
              {!esUnFirmante && <div className="alert alert-info py-2 small mb-3"><i className="bi bi-grip-vertical me-1"></i><strong>Arrastra</strong> las tarjetas para reordenar.</div>}
              {firmantes.map((f, index) => {
                const col = obtenerColor(index);
                const ef = errors.firmantes?.[index] || {};
                return (
                  <div key={f.id} draggable={!esUnFirmante} onDragStart={() => handleDragStart(index)} onDragOver={(e) => handleDragOver(e, index)} onDrop={handleDrop}
                    className="rounded-3 mb-3 p-3" style={{ borderLeft: `5px solid ${col.border}`, backgroundColor: col.bg, cursor: esUnFirmante ? 'default' : 'grab' }}>
                    <div className="d-flex align-items-center justify-content-between mb-3">
                      <div className="d-flex align-items-center gap-2">
                        {!esUnFirmante && <i className="bi bi-grip-vertical text-muted" style={{ fontSize: '1.2rem' }}></i>}
                        <span className="rounded-circle d-flex align-items-center justify-content-center fw-bold" style={{ width: 32, height: 32, backgroundColor: col.border, color: 'white', fontSize: '0.85rem' }}>{index + 1}</span>
                        <span className="fw-semibold" style={{ color: col.text }}>Firmante {index + 1}{f.tipoFirmante === 'interno' && <span className="badge bg-info ms-2" style={{ fontSize: '0.65rem' }}>Interno</span>}</span>
                      </div>
                      {firmantes.length > 1 && <button className="btn btn-outline-danger btn-sm" onClick={() => eliminarFirmante(f.id)}><i className="bi bi-trash"></i></button>}
                    </div>
                    <div className="row g-2">
                      <div className="col-md-3">
                        <label className="form-label small fw-semibold mb-1">Cédula *</label>
                        <div className="input-group input-group-sm">
                          <input type="text" value={f.cedula} onChange={e => actualizarFirmante(f.id, 'cedula', limpiarNumero(e.target.value))} onKeyDown={e => e.key === 'Enter' && buscarPersona(f.id, f.cedula)} className={`form-control ${ef.cedula ? 'is-invalid' : ''}`} placeholder="Número" />
                          <button className="btn btn-outline-primary" onClick={() => buscarPersona(f.id, f.cedula)} disabled={!f.cedula || f.buscando}>{f.buscando ? <span className="spinner-border spinner-border-sm"></span> : <i className="bi bi-search"></i>}</button>
                        </div>
                        {ef.cedula && <small className="text-danger">{ef.cedula}</small>}
                      </div>
                      <div className="col-md-3">
                        <label className="form-label small fw-semibold mb-1">Nombre completo *</label>
                        <input type="text" value={f.nombre} onChange={e => actualizarFirmante(f.id, 'nombre', limpiarTexto(e.target.value))} className={`form-control form-control-sm ${ef.nombre ? 'is-invalid' : ''}`} placeholder="Nombres y apellidos" />
                        {ef.nombre && <small className="text-danger">{ef.nombre}</small>}
                      </div>
                      <div className="col-md-3">
                        <label className="form-label small fw-semibold mb-1">Correo</label>
                        <input type="email" value={f.correo} onChange={e => actualizarFirmante(f.id, 'correo', e.target.value)} className={`form-control form-control-sm ${ef.correo ? 'is-invalid' : ''}`} placeholder="correo@ejemplo.com" />
                        {ef.correo && <small className="text-danger">{ef.correo}</small>}
                      </div>
                      <div className="col-md-3">
                        <label className="form-label small fw-semibold mb-1">Celular</label>
                        <input type="tel" value={f.celular} onChange={e => actualizarFirmante(f.id, 'celular', limpiarNumero(e.target.value))} className={`form-control form-control-sm ${ef.celular ? 'is-invalid' : ''}`} placeholder="3001234567" maxLength={10} />
                        {ef.celular && <small className="text-danger">{ef.celular}</small>}
                      </div>
                    </div>
                    {ef.contacto && <small className="text-danger d-block mt-1">{ef.contacto}</small>}
                    <div className="d-flex align-items-center gap-3 mt-3 flex-wrap">
                      <small className="fw-semibold text-muted">Enviar por:</small>
                      {[
                        { id: 'correo', icon: 'bi-envelope-fill', label: 'Correo', color: '#0d6efd', disabled: !f.correo },
                        { id: 'sms', icon: 'bi-chat-dots-fill', label: 'SMS', color: '#198754', disabled: !f.celular },
                        { id: 'whatsapp', icon: 'bi-whatsapp', label: 'WhatsApp', color: '#25D366', disabled: !f.celular }
                      ].map(m => (
                        <div key={m.id} className="form-check form-check-inline mb-0">
                          <input type="checkbox" className="form-check-input" id={`${m.id}-${f.id}`} checked={f.metodoEnvio.includes(m.id)} onChange={() => toggleMetodo(f.id, m.id)} disabled={m.disabled} />
                          <label className="form-check-label small" htmlFor={`${m.id}-${f.id}`}><i className={`bi ${m.icon} me-1`} style={{ color: m.color }}></i>{m.label}</label>
                        </div>
                      ))}
                      {ef.metodoEnvio && <small className="text-danger fw-semibold"><i className="bi bi-exclamation-triangle me-1"></i>{ef.metodoEnvio}</small>}
                    </div>
                  </div>
                );
              })}
              {firmantes.length < 50 && <div className="text-center mb-3"><button className="btn btn-outline-success btn-sm" onClick={agregarFirmante}><i className="bi bi-person-plus me-1"></i>Agregar otro firmante ({firmantes.length}/50)</button></div>}
              <div className="d-flex justify-content-between mt-4">
                <button className="btn btn-outline-secondary" onClick={retroceder}><i className="bi bi-arrow-left me-1"></i> Atrás</button>
                <button className="btn btn-primary px-5" style={{ backgroundColor: '#1a1e4b', borderColor: '#1a1e4b' }} onClick={avanzar}>Siguiente <i className="bi bi-arrow-right ms-1"></i></button>
              </div>
            </div>
          </div>
        )}

        {/* PASO 3 */}
        {paso === 3 && (
          <div className="card shadow-sm border-0" style={{ borderRadius: 12 }}>
            <div className="card-body p-4">
              <h5 className="fw-bold mb-4" style={{ color: '#1a1e4b' }}><i className="bi bi-sliders me-2"></i>Configuración de Firma</h5>
              <div className="mb-4">
                <label className="form-label fw-semibold mb-3">Orden de firma</label>
                {esUnFirmante ? (
                  <div className="d-flex align-items-center gap-3 p-3 rounded-3 border border-success" style={{ backgroundColor: '#f0fdf4' }}>
                    <span style={{ fontSize: '2rem' }}>📝</span>
                    <div><div className="fw-bold text-success">En orden (único firmante)</div><small className="text-muted">El firmante recibirá el documento directamente.</small></div>
                    <span className="badge bg-success ms-auto">Automático</span>
                  </div>
                ) : (
                  <div className="row g-3">
                    {[{ valor: 'paralelo', icon: '⚡', titulo: 'Todos al tiempo', desc: 'Todos reciben el documento simultáneamente.', tip: 'Más rápido · Ideal para comités' },
                      { valor: 'secuencial', icon: '📝', titulo: 'En orden', desc: 'Firman uno por uno. El siguiente espera al anterior.', tip: 'Más control · Ideal para contratos' }
                    ].map(op => (
                      <div key={op.valor} className="col-md-6">
                        <div className={`card h-100 ${ordenFirma === op.valor ? 'border-success border-2' : 'border'}`} style={{ cursor: 'pointer', backgroundColor: ordenFirma === op.valor ? '#f0fdf4' : undefined }} onClick={() => setOrdenFirma(op.valor)}>
                          <div className="card-body text-center p-4">
                            <div style={{ fontSize: '2.5rem' }}>{op.icon}</div>
                            <h6 className="fw-bold mt-2 mb-1">{op.titulo}</h6>
                            <p className="text-muted small mb-2">{op.desc}</p>
                            <small className="text-muted fst-italic">{op.tip}</small>
                            {ordenFirma === op.valor && <div className="mt-2"><span className="badge bg-success">✓ Seleccionado</span></div>}
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </div>
              {!esUnFirmante && ordenFirma === 'secuencial' && (
                <div className="mb-4">
                  <label className="form-label fw-semibold mb-2"><i className="bi bi-grip-vertical me-1"></i>Orden de los firmantes</label>
                  <p className="text-muted small mb-2">Arrastra para cambiar el orden de firma.</p>
                  <div className="list-group">
                    {firmantes.map((f, i) => {
                      const col = obtenerColor(i);
                      return (
                        <div key={f.id} draggable onDragStart={() => handleDragStart(i)} onDragOver={(e) => handleDragOver(e, i)} onDrop={handleDrop}
                          className="list-group-item d-flex align-items-center gap-3" style={{ borderLeft: `4px solid ${col.border}`, cursor: 'grab' }}>
                          <i className="bi bi-grip-vertical text-muted" style={{ fontSize: '1.2rem' }}></i>
                          <span className="rounded-circle d-flex align-items-center justify-content-center fw-bold" style={{ width: 30, height: 30, backgroundColor: col.border, color: 'white', fontSize: '0.8rem', flexShrink: 0 }}>{i + 1}</span>
                          <div className="flex-grow-1"><strong>{f.nombre || '(sin nombre)'}</strong><br /><small className="text-muted">CC {f.cedula} · {f.correo || f.celular || 'sin contacto'}</small></div>
                          <span className="badge bg-secondary" style={{ fontSize: '0.7rem' }}>{i === 0 ? 'Firma primero' : `Después de #${i}`}</span>
                        </div>
                      );
                    })}
                  </div>
                </div>
              )}
              <div className="border rounded-3 p-3" style={{ backgroundColor: '#fafbfc' }}>
                <div className="d-flex align-items-center justify-content-between mb-2">
                  <div>
                    <span className="fw-semibold"><i className="bi bi-calendar-x me-2 text-warning"></i>Fecha de caducidad del enlace</span>
                    <br /><small className="text-muted">Tiempo límite para que los firmantes completen el proceso</small>
                  </div>
                  <div className="form-check form-switch mb-0">
                    <input type="checkbox" className="form-check-input" id="switchCaducidad" checked={tieneCaducidad} onChange={e => setTieneCaducidad(e.target.checked)} style={{ width: '2.5rem', height: '1.3rem' }} />
                  </div>
                </div>
                {tieneCaducidad && (
                  <div className="mt-3">
                    <div className="d-flex align-items-center gap-3 flex-wrap">
                      <div>
                        <label className="form-label small fw-semibold mb-1">Días de firma</label>
                        <input type="number" min={1} max={365} value={diasCaducidad}
                          onChange={e => { const d = e.target.value; setDiasCaducidad(d); if (d && parseInt(d) > 0) { const f = new Date(Date.now() + parseInt(d)*86400000); setFechaCaducidad(f.toISOString().split('T')[0]); } else setFechaCaducidad(''); }}
                          onFocus={e => e.target.select()} className={`form-control form-control-sm text-center ${errors.caducidad ? 'is-invalid' : ''}`} placeholder="Ej: 7" style={{ width: 90 }} />
                      </div>
                      <div className="text-muted fw-bold mt-3">↔</div>
                      <div>
                        <label className="form-label small fw-semibold mb-1">Fecha límite</label>
                        <input type="date" min={fechaMinimaStr} value={fechaCaducidad}
                          onChange={e => { const f = e.target.value; setFechaCaducidad(f); if (f) { const hoy = new Date(); hoy.setHours(0,0,0,0); const lim = new Date(f+'T00:00:00'); const dias = Math.round((lim-hoy)/86400000); setDiasCaducidad(dias > 0 ? String(dias) : '1'); } else setDiasCaducidad(''); }}
                          className={`form-control form-control-sm ${errors.caducidad ? 'is-invalid' : ''}`} style={{ width: 170 }} />
                      </div>
                      {diasCaducidad && parseInt(diasCaducidad) > 0 && fechaCaducidad && (
                        <div className="mt-3"><small className="text-muted">📅 Vence en <strong>{diasCaducidad} día{parseInt(diasCaducidad) > 1 ? 's' : ''}</strong></small></div>
                      )}
                    </div>
                    {errors.caducidad && <small className="text-danger d-block mt-1">{errors.caducidad}</small>}
                  </div>
                )}
              </div>
              {/* ⭐ V5.8: Cards de configuración del proceso */}
<div className="mt-4">
  <label className="form-label fw-semibold mb-1">
    <i className="bi bi-diagram-3 me-2"></i>Pasos del proceso de firma
  </label>
  <p className="text-muted small mb-3">
    Todos activos por defecto. Haz clic en una tarjeta para desactivarla.
  </p>

  <div className="row g-3">

    {/* OTP */}
    <div className="col-6 col-md-3">
      <div
        onClick={() => setRequiereOtp(v => !v)}
        className="rounded-3 p-3 text-center position-relative"
        style={{
          border: `2px solid ${requiereOtp ? '#1D9E75' : '#dee2e6'}`,
          background: requiereOtp ? '#E1F5EE' : 'var(--bs-light)',
          cursor: 'pointer',
          transition: 'all 0.18s',
          userSelect: 'none',
          opacity: requiereOtp ? 1 : 0.55
        }}
      >
        {requiereOtp && (
          <span style={{ position: 'absolute', top: 8, right: 10, fontSize: 13, color: '#0F6E56', fontWeight: 700 }}>✓</span>
        )}
        <div style={{ fontSize: 32, marginBottom: 8 }}>🔐</div>
        <div className="fw-semibold" style={{ fontSize: 13, color: requiereOtp ? '#085041' : '#6c757d' }}>OTP</div>
        <div style={{ fontSize: 11, color: requiereOtp ? '#0F6E56' : '#adb5bd', marginTop: 3 }}>Código al cel/correo</div>
        <div className="mt-2">
          <span style={{
            fontSize: 10, fontWeight: 600, padding: '2px 8px', borderRadius: 20,
            background: requiereOtp ? '#0F6E56' : '#dee2e6',
            color: requiereOtp ? 'white' : '#6c757d'
          }}>
            {requiereOtp ? 'Activo' : 'Inactivo'}
          </span>
        </div>
      </div>
    </div>

    {/* FOTO */}
    <div className="col-6 col-md-3">
      <div
        onClick={() => setRequiereFoto(v => !v)}
        className="rounded-3 p-3 text-center position-relative"
        style={{
          border: `2px solid ${requiereFoto ? '#1D9E75' : '#dee2e6'}`,
          background: requiereFoto ? '#E1F5EE' : 'var(--bs-light)',
          cursor: 'pointer',
          transition: 'all 0.18s',
          userSelect: 'none',
          opacity: requiereFoto ? 1 : 0.55
        }}
      >
        {requiereFoto && (
          <span style={{ position: 'absolute', top: 8, right: 10, fontSize: 13, color: '#0F6E56', fontWeight: 700 }}>✓</span>
        )}
        <div style={{ fontSize: 32, marginBottom: 8 }}>📷</div>
        <div className="fw-semibold" style={{ fontSize: 13, color: requiereFoto ? '#085041' : '#6c757d' }}>Selfie</div>
        <div style={{ fontSize: 11, color: requiereFoto ? '#0F6E56' : '#adb5bd', marginTop: 3 }}>Verificación facial</div>
        <div className="mt-2">
          <span style={{
            fontSize: 10, fontWeight: 600, padding: '2px 8px', borderRadius: 20,
            background: requiereFoto ? '#0F6E56' : '#dee2e6',
            color: requiereFoto ? 'white' : '#6c757d'
          }}>
            {requiereFoto ? 'Activo' : 'Inactivo'}
          </span>
        </div>
      </div>
    </div>

    {/* GRAFO — solo si es un firmante */}
    <div className="col-6 col-md-3">
      {esUnFirmante ? (
        <div
          onClick={() => setRequiereGrafo(v => !v)}
          className="rounded-3 p-3 text-center position-relative"
          style={{
            border: `2px solid ${requiereGrafo ? '#1D9E75' : '#dee2e6'}`,
            background: requiereGrafo ? '#E1F5EE' : 'var(--bs-light)',
            cursor: 'pointer',
            transition: 'all 0.18s',
            userSelect: 'none',
            opacity: requiereGrafo ? 1 : 0.55
          }}
        >
          {requiereGrafo && (
            <span style={{ position: 'absolute', top: 8, right: 10, fontSize: 13, color: '#0F6E56', fontWeight: 700 }}>✓</span>
          )}
          <div style={{ fontSize: 32, marginBottom: 8 }}>✍️</div>
          <div className="fw-semibold" style={{ fontSize: 13, color: requiereGrafo ? '#085041' : '#6c757d' }}>Grafo</div>
          <div style={{ fontSize: 11, color: requiereGrafo ? '#0F6E56' : '#adb5bd', marginTop: 3 }}>Firma manuscrita</div>
          <div className="mt-2">
            <span style={{
              fontSize: 10, fontWeight: 600, padding: '2px 8px', borderRadius: 20,
              background: requiereGrafo ? '#0F6E56' : '#dee2e6',
              color: requiereGrafo ? 'white' : '#6c757d'
            }}>
              {requiereGrafo ? 'Activo' : 'Inactivo'}
            </span>
          </div>
        </div>
      ) : (
        <div className="rounded-3 p-3 text-center position-relative"
          style={{ border: '2px solid #dee2e6', background: 'var(--bs-light)', opacity: 0.45, userSelect: 'none' }}>
          <div style={{ fontSize: 32, marginBottom: 8 }}>✍️</div>
          <div className="fw-semibold" style={{ fontSize: 13, color: '#6c757d' }}>Grafo</div>
          <div style={{ fontSize: 11, color: '#adb5bd', marginTop: 3 }}>Solo 1 firmante</div>
          <div className="mt-2">
            <span style={{ fontSize: 10, fontWeight: 600, padding: '2px 8px', borderRadius: 20, background: '#dee2e6', color: '#6c757d' }}>
              No aplica
            </span>
          </div>
        </div>
      )}
    </div>

    {/* CERTICÁMARA — siempre fijo */}
    <div className="col-6 col-md-3">
      <div className="rounded-3 p-3 text-center position-relative"
        style={{ border: '2px solid #378ADD', background: '#E6F1FB', userSelect: 'none', opacity: 0.85 }}>
        <span style={{ position: 'absolute', top: 6, right: 8, fontSize: 10, fontWeight: 600, background: '#B5D4F4', color: '#0C447C', borderRadius: 4, padding: '1px 6px' }}>Fijo</span>
        <div style={{ fontSize: 32, marginBottom: 8 }}>🔒</div>
        <div className="fw-semibold" style={{ fontSize: 13, color: '#0C447C' }}>Certicámara</div>
        <div style={{ fontSize: 11, color: '#185FA5', marginTop: 3 }}>Firma digital</div>
        <div className="mt-2">
          <span style={{ fontSize: 10, fontWeight: 600, padding: '2px 8px', borderRadius: 20, background: '#185FA5', color: 'white' }}>
            Siempre activo
          </span>
        </div>
      </div>
    </div>

  </div>
</div>
              <div className="d-flex justify-content-between mt-4">
                <button className="btn btn-outline-secondary" onClick={retroceder}><i className="bi bi-arrow-left me-1"></i> Atrás</button>
                <button className="btn btn-primary px-5" style={{ backgroundColor: '#1a1e4b', borderColor: '#1a1e4b' }} onClick={avanzar}>{esUnFirmante ? 'Posicionar firma' : 'Confirmar'}<i className="bi bi-arrow-right ms-1"></i></button>
              </div>
            </div>
          </div>
        )}

        {/* PASO 4 — POSICIONADOR */}
        {paso === 4 && esUnFirmante && (() => {
          const TOOLS = [
            { id: 'firma',   icon: '✍️', label: 'Firma',   color: '#dc3545', bg: 'rgba(220,53,69,0.12)',  border: '#dc3545' },
            { id: 'fecha',   icon: '📅', label: 'Fecha',   color: '#0d6efd', bg: 'rgba(13,110,253,0.10)', border: '#0d6efd' },
            { id: 'texto',   icon: 'T',  label: 'Texto',   color: '#198754', bg: 'rgba(25,135,84,0.10)',  border: '#198754' },
            { id: 'casilla', icon: '☐',  label: 'Casilla', color: '#6f42c1', bg: 'rgba(111,66,193,0.10)',border: '#6f42c1' },
          ];
          const getToolCfg = (tipo) => TOOLS.find(t => t.id === tipo) || TOOLS[0];
          const elSel = elementos.find(e => e.id === elementoSeleccionado);
          const CORNER_SIZE = 8;
          const CORNERS = [
            { id: 'nw', style: { top: -CORNER_SIZE/2, left: -CORNER_SIZE/2, cursor: 'nw-resize' } },
            { id: 'ne', style: { top: -CORNER_SIZE/2, right: -CORNER_SIZE/2, cursor: 'ne-resize' } },
            { id: 'sw', style: { bottom: -CORNER_SIZE/2, left: -CORNER_SIZE/2, cursor: 'sw-resize' } },
            { id: 'se', style: { bottom: -CORNER_SIZE/2, right: -CORNER_SIZE/2, cursor: 'se-resize' } },
          ];
          // ⭐ SPRINT 4: dimensiones reales del PDF
          const canvasW = pdfRealW * scale;
          const canvasH = pdfRealH * scale;

          return (
            <div style={{ display: 'flex', flexDirection: 'column', height: 'calc(100vh - 180px)', borderRadius: 12, overflow: 'hidden', boxShadow: '0 4px 24px rgba(0,0,0,0.15)' }}>

              {/* Top bar */}
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', background: '#1e293b', padding: '10px 16px', gap: 12, flexShrink: 0 }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                  <button onClick={retroceder} style={{ background: '#374151', border: 'none', color: '#e5e7eb', padding: '6px 14px', borderRadius: 6, cursor: 'pointer', fontSize: 13 }}>← Atrás</button>
                  <span style={{ color: '#94a3b8', fontSize: 12 }}>Arrastra los elementos para posicionarlos en el documento</span>
                </div>
                <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 4, background: '#374151', borderRadius: 6, padding: '3px 8px' }}>
                    <button onClick={() => setScale(s => Math.max(0.5, +(s-0.2).toFixed(1)))} style={{ background: 'none', border: 'none', color: '#e5e7eb', cursor: 'pointer', fontSize: 16, width: 24, height: 24 }}>−</button>
                    <span style={{ color: '#f1f5f9', fontSize: 12, minWidth: 42, textAlign: 'center' }}>{Math.round(scale*100)}%</span>
                    <button onClick={() => setScale(s => Math.min(2.2, +(s+0.2).toFixed(1)))} style={{ background: 'none', border: 'none', color: '#e5e7eb', cursor: 'pointer', fontSize: 16, width: 24, height: 24 }}>+</button>
                  </div>
                  {totalPaginas > 1 && (
                    <div style={{ display: 'flex', alignItems: 'center', gap: 4, background: '#374151', borderRadius: 6, padding: '3px 8px' }}>
                      <button onClick={() => setPaginaActual(p => Math.max(0, p-1))} disabled={paginaActual===0} style={{ background: 'none', border: 'none', color: paginaActual===0 ? '#6b7280' : '#e5e7eb', cursor: paginaActual===0 ? 'default' : 'pointer', fontSize: 12 }}>◀</button>
                      <span style={{ color: '#f1f5f9', fontSize: 12, minWidth: 50, textAlign: 'center' }}>{paginaActual+1} / {totalPaginas}</span>
                      <button onClick={() => setPaginaActual(p => Math.min(totalPaginas-1, p+1))} disabled={paginaActual>=totalPaginas-1} style={{ background: 'none', border: 'none', color: paginaActual>=totalPaginas-1 ? '#6b7280' : '#e5e7eb', cursor: paginaActual>=totalPaginas-1 ? 'default' : 'pointer', fontSize: 12 }}>▶</button>
                    </div>
                  )}
                  <button onClick={avanzar} style={{ background: 'linear-gradient(135deg,#22c55e,#16a34a)', border: 'none', color: '#fff', padding: '7px 20px', borderRadius: 6, cursor: 'pointer', fontSize: 13, fontWeight: 700 }}>Confirmar →</button>
                </div>
              </div>

              <div style={{ display: 'flex', flex: 1, overflow: 'hidden' }}>
                {/* Panel herramientas */}
                <div style={{ width: 72, background: '#0f172a', display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '12px 0', gap: 6, borderRight: '1px solid #1e293b', flexShrink: 0 }}>
                  <button onClick={() => setHerramienta('mover')} title="Mover"
                    style={{ width: 52, height: 52, borderRadius: 10, border: herramienta==='mover' ? '2px solid #3b82f6' : '2px solid transparent', background: herramienta==='mover' ? 'rgba(59,130,246,0.15)' : 'transparent', cursor: 'pointer', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 2 }}>
                    <span style={{ fontSize: 20 }}>↖</span>
                    <span style={{ fontSize: 9, color: herramienta==='mover' ? '#60a5fa' : '#64748b' }}>Mover</span>
                  </button>
                  <div style={{ width: 40, height: 1, background: '#1e293b', margin: '4px 0' }} />
                  {TOOLS.map(t => (
                    <button key={t.id} onClick={() => { setHerramienta(t.id); if (t.id === 'texto') setMostrarInputTexto(true); }} title={t.label}
                      style={{ width: 52, height: 52, borderRadius: 10, border: herramienta===t.id ? `2px solid ${t.color}` : '2px solid transparent', background: herramienta===t.id ? t.bg : 'transparent', cursor: 'pointer', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 2 }}>
                      <span style={{ fontSize: t.id==='texto' ? 22 : 20, color: herramienta===t.id ? t.color : '#94a3b8', fontWeight: t.id==='texto' ? 800 : 'normal' }}>{t.icon}</span>
                      <span style={{ fontSize: 9, color: herramienta===t.id ? t.color : '#64748b' }}>{t.label}</span>
                    </button>
                  ))}
                  {mostrarInputTexto && (
                    <div style={{ position: 'absolute', left: 80, top: 160, background: '#1e293b', border: '1px solid #374151', borderRadius: 8, padding: 12, zIndex: 200, width: 240, boxShadow: '0 8px 24px rgba(0,0,0,0.4)' }}>
                      <div style={{ color: '#e5e7eb', fontSize: 12, marginBottom: 8, fontWeight: 600 }}>Texto a insertar</div>
                      <input autoFocus type="text" value={textoInput} onChange={e => setTextoInput(e.target.value)}
                        onKeyDown={e => { if (e.key==='Enter') agregarTexto(); if (e.key==='Escape') { setMostrarInputTexto(false); setHerramienta('mover'); } }}
                        placeholder="Ej: Firma del paciente"
                        style={{ width: '100%', background: '#111827', border: '1px solid #374151', borderRadius: 4, padding: '6px 8px', color: '#f1f5f9', fontSize: 13, outline: 'none', marginBottom: 8 }} />
                      <div style={{ display: 'flex', gap: 6 }}>
                        <button onClick={agregarTexto} style={{ flex: 1, background: '#198754', border: 'none', color: '#fff', borderRadius: 4, padding: '5px 0', cursor: 'pointer', fontSize: 12 }}>Agregar</button>
                        <button onClick={() => { setMostrarInputTexto(false); setHerramienta('mover'); }} style={{ flex: 1, background: '#374151', border: 'none', color: '#e5e7eb', borderRadius: 4, padding: '5px 0', cursor: 'pointer', fontSize: 12 }}>Cancelar</button>
                      </div>
                    </div>
                  )}
                </div>

                {/* Área del canvas */}
                <div
                  onClick={handleCanvasClick}
                  style={{ flex: 1, overflow: 'auto', background: '#374151', display: 'flex', justifyContent: 'center', alignItems: 'flex-start', padding: 24, cursor: herramienta !== 'mover' ? 'crosshair' : 'default' }}
                >
                  {loadingPdf ? (
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: 500, color: '#94a3b8', flexDirection: 'column', gap: 16 }}>
                      <div style={{ width: 40, height: 40, border: '3px solid #374151', borderTopColor: '#3b82f6', borderRadius: '50%', animation: 'spin 1s linear infinite' }}></div>
                      Cargando PDF...
                    </div>
                  ) : (
                    // ⭐ wrapperRef en este div — es el sistema de coordenadas de los elementos
                    <div ref={wrapperRef} style={{ position: 'relative', flexShrink: 0, width: canvasW, height: canvasH }}>
                      <canvas ref={canvasRef} style={{ display: 'block', boxShadow: '0 8px 32px rgba(0,0,0,0.5)', userSelect: 'none' }} />
                      {elementos.filter(el => el.pagina === paginaActual).map(el => {
                        const cfg = getToolCfg(el.tipo);
                        const vp = elVisual(el);
                        const isSelected = el.id === elementoSeleccionado;
                        return (
                          <div key={el.id} onMouseDown={e => { e.stopPropagation(); handleElMouseDown(e, el.id); }}
                            style={{ position: 'absolute', left: vp.left, top: vp.top, width: vp.width, height: vp.height,
                              border: `2px ${isSelected ? 'solid' : 'dashed'} ${cfg.border}`, backgroundColor: cfg.bg,
                              borderRadius: el.tipo==='casilla' ? 4 : 6, cursor: 'grab',
                              display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
                              userSelect: 'none', zIndex: isSelected ? 30 : 20,
                              boxShadow: isSelected ? `0 0 0 2px ${cfg.color}44` : 'none', overflow: 'hidden' }}>
                            {el.tipo==='firma' && (<><span style={{ fontSize: Math.max(14, vp.height*0.35), color: cfg.color, lineHeight: 1 }}>✍️</span><span style={{ fontSize: Math.max(9, vp.height*0.14), color: cfg.color, fontWeight: 700, marginTop: 2 }}>{el.label||'Firma'}</span></>)}
                            {el.tipo==='fecha' && (<><span style={{ fontSize: Math.max(10, vp.height*0.28), color: cfg.color }}>📅</span><span style={{ fontSize: Math.max(8, vp.height*0.22), color: cfg.color, fontWeight: 600 }}>{el.label||'Fecha'}</span></>)}
                            {el.tipo==='texto' && (<span style={{ fontSize: Math.max(9, vp.height*0.4), color: cfg.color, fontWeight: 700, padding: '0 4px', textAlign: 'center', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', maxWidth: '100%' }}>{el.label||'Texto'}</span>)}
                            {el.tipo==='casilla' && (<span style={{ fontSize: Math.max(12, vp.height*0.6), color: cfg.color, lineHeight: 1 }}>☐</span>)}
                            {isSelected && (
                              <button onMouseDown={e => e.stopPropagation()} onClick={e => { e.stopPropagation(); eliminarElemento(el.id); }}
                                style={{ position: 'absolute', top: -10, right: -10, width: 20, height: 20, borderRadius: '50%', background: '#dc3545', border: 'none', color: '#fff', cursor: 'pointer', fontSize: 12, display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 50, lineHeight: 1, fontWeight: 700 }}>×</button>
                            )}
                            {isSelected && CORNERS.map(corner => (
                              <div key={corner.id} onMouseDown={e => { e.stopPropagation(); handleCornerMouseDown(e, el.id, corner.id); }}
                                style={{ position: 'absolute', width: CORNER_SIZE, height: CORNER_SIZE, borderRadius: 2, background: '#fff', border: `2px solid ${cfg.color}`, zIndex: 40, ...corner.style }} />
                            ))}
                          </div>
                        );
                      })}
                    </div>
                  )}
                </div>

                {/* Panel derecho */}
                <div style={{ width: 220, background: '#0f172a', borderLeft: '1px solid #1e293b', display: 'flex', flexDirection: 'column', overflow: 'auto', flexShrink: 0 }}>
                  <div style={{ padding: 14, borderBottom: '1px solid #1e293b' }}>
                    <div style={{ color: '#94a3b8', fontSize: 11, fontWeight: 700, letterSpacing: 1, marginBottom: 12 }}>ELEMENTOS</div>
                    {elementos.map(el => {
                      const cfg = getToolCfg(el.tipo);
                      const isSelected = el.id === elementoSeleccionado;
                      return (
                        <div key={el.id} onClick={() => setElementoSeleccionado(el.id)}
                          style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '7px 8px', borderRadius: 6, cursor: 'pointer', marginBottom: 4, background: isSelected ? 'rgba(59,130,246,0.12)' : 'transparent', border: isSelected ? '1px solid #3b82f6' : '1px solid transparent' }}>
                          <span style={{ fontSize: 14, color: cfg.color }}>{cfg.icon}</span>
                          <span style={{ color: '#e5e7eb', fontSize: 12, flex: 1, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{el.label||cfg.label}</span>
                          <button onClick={e => { e.stopPropagation(); eliminarElemento(el.id); }} style={{ background: 'none', border: 'none', color: '#6b7280', cursor: 'pointer', fontSize: 14, padding: 0, lineHeight: 1 }}>×</button>
                        </div>
                      );
                    })}
                    {elementos.length === 0 && <div style={{ color: '#64748b', fontSize: 12, textAlign: 'center', padding: 16 }}>Usa las herramientas para agregar elementos</div>}
                  </div>
                  {elSel && (
                    <div style={{ padding: 14 }}>
                      <div style={{ color: '#94a3b8', fontSize: 11, fontWeight: 700, letterSpacing: 1, marginBottom: 12 }}>PROPIEDADES</div>
                      {(elSel.tipo==='texto' || elSel.tipo==='firma') && (
                        <div style={{ marginBottom: 12 }}>
                          <label style={{ color: '#64748b', fontSize: 10, display: 'block', marginBottom: 4 }}>ETIQUETA</label>
                          <input type="text" value={elSel.label} onChange={e => setElementos(prev => prev.map(el => el.id===elSel.id ? { ...el, label: e.target.value } : el))}
                            style={{ width: '100%', background: '#1e293b', border: '1px solid #374151', borderRadius: 4, padding: '6px 8px', color: '#f1f5f9', fontSize: 12, outline: 'none' }} />
                        </div>
                      )}
                      <div style={{ marginBottom: 12 }}>
                        <label style={{ color: '#64748b', fontSize: 10, display: 'block', marginBottom: 4 }}>PÁGINA</label>
                        <input type="number" min={1} max={totalPaginas} value={elSel.pagina+1}
                          onChange={e => setElementos(prev => prev.map(el => el.id===elSel.id ? { ...el, pagina: Math.max(0,(parseInt(e.target.value)||1)-1) } : el))}
                          style={{ width: '100%', background: '#1e293b', border: '1px solid #374151', borderRadius: 4, padding: '5px 6px', color: '#f1f5f9', fontSize: 12, outline: 'none' }} />
                      </div>
                      <div style={{ color: '#64748b', fontSize: 10, marginBottom: 8 }}>POSICIÓN RÁPIDA</div>
                      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 5 }}>
                        {[['↖ Sup-Izq', 72, 680], ['↗ Sup-Der', 390, 680], ['← Med-Izq', 72, 400], ['→ Med-Der', 390, 400], ['↙ Inf-Izq', 72, 80], ['↘ Inf-Der', 390, 80]].map(([lbl, x, y]) => (
                          <button key={lbl} onClick={() => setElementos(prev => prev.map(el => el.id===elSel.id ? { ...el, x, y, pagina: paginaActual } : el))}
                            style={{ background: '#1e293b', border: '1px solid #374151', borderRadius: 4, color: '#94a3b8', fontSize: 10, padding: '5px 2px', cursor: 'pointer' }}>{lbl}</button>
                        ))}
                      </div>
                    </div>
                  )}
                </div>
              </div>
              <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
            </div>
          );
        })()}

        {/* ÚLTIMO PASO */}
        {paso === totalPasos && (
          <div className="card shadow-sm border-0" style={{ borderRadius: 12 }}>
            <div className="card-body p-4">
              <h5 className="fw-bold mb-4" style={{ color: '#1a1e4b' }}><i className="bi bi-send-check me-2"></i>Confirmar y Enviar</h5>

              <div className="card mb-3 border-0 bg-light">
                <div className="card-body p-3">
                  <div className="d-flex justify-content-between align-items-start mb-2">
                    <span className="fw-semibold small text-muted">📄 DOCUMENTO</span>
                    <button className="btn btn-link btn-sm p-0 text-decoration-none" onClick={() => setPaso(1)}><i className="bi bi-pencil me-1"></i>Editar</button>
                  </div>
                  <div className="row">
                    <div className="col-md-6"><small className="text-muted d-block">Nombre:</small><strong>{nombreDocumento}</strong></div>
                    <div className="col-md-6"><small className="text-muted d-block">Archivo:</small><strong>{documento?.name}</strong><small className="text-muted ms-2">({(documento?.size/1024/1024).toFixed(2)} MB)</small></div>
                  </div>
                </div>
              </div>

              <div className="card mb-3 border-0 bg-light">
                <div className="card-body p-3">
                  <div className="d-flex justify-content-between align-items-start mb-2">
                    <span className="fw-semibold small text-muted">👥 FIRMANTES ({firmantes.length})</span>
                    <button className="btn btn-link btn-sm p-0 text-decoration-none" onClick={() => setPaso(2)}><i className="bi bi-pencil me-1"></i>Editar</button>
                  </div>
                  <div className="table-responsive">
                    <table className="table table-sm mb-0">
                      <thead className="table-light"><tr><th style={{ width: 36 }}>#</th><th>Nombre</th><th>Cédula</th><th>Contacto</th><th>Envío</th></tr></thead>
                      <tbody>
                        {firmantes.map((f, i) => { const col = obtenerColor(i); return (
                          <tr key={f.id}>
                            <td><span className="rounded-circle d-inline-flex align-items-center justify-content-center fw-bold" style={{ width: 26, height: 26, backgroundColor: col.border, color: 'white', fontSize: '0.75rem' }}>{i+1}</span></td>
                            <td><strong>{f.nombre}</strong></td>
                            <td>{f.cedula}</td>
                            <td>{f.correo && <small className="d-block">📧 {f.correo}</small>}{f.celular && <small className="d-block">📱 {f.celular}</small>}</td>
                            <td>{f.metodoEnvio.map(m => <span key={m} className="badge bg-secondary me-1" style={{ fontSize: '0.65rem' }}>{m==='correo'?'📧':m==='sms'?'💬':'🟢'} {m}</span>)}</td>
                          </tr>
                        ); })}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>

              <div className="card mb-3 border-0 bg-light">
                <div className="card-body p-3">
                  <div className="d-flex justify-content-between align-items-start mb-2">
                    <span className="fw-semibold small text-muted">⚙️ OPCIONES</span>
                    <button className="btn btn-link btn-sm p-0 text-decoration-none" onClick={() => setPaso(3)}><i className="bi bi-pencil me-1"></i>Editar</button>
                  </div>
                  <div className="row">
                    <div className="col-md-6"><small className="text-muted d-block">Orden de firma:</small><strong>{esUnFirmante ? '📝 En orden (único firmante)' : ordenFirma==='paralelo' ? '⚡ Todos al tiempo' : '📝 En orden'}</strong></div>
                    <div className="col-md-6"><small className="text-muted d-block">Caducidad:</small><strong>{tieneCaducidad ? diasCaducidad ? `⏰ ${diasCaducidad} día${parseInt(diasCaducidad)>1?'s':''}` : `📅 ${new Date(fechaCaducidad).toLocaleDateString('es-CO')}` : '∞ Sin límite'}</strong></div>
                  </div>
                </div>
              </div>

              {process.env.NODE_ENV !== 'production' && (
                <div className="alert alert-warning py-2 d-flex align-items-center gap-3 mb-3">
                  <i className="bi bi-cone-striped text-warning" style={{ fontSize: '1.3rem' }}></i>
                  <div className="flex-grow-1">
                    <strong>Modo desarrollo</strong>
                    <small className="d-block text-muted">Omite Certicámara y finaliza el documento localmente</small>
                  </div>
                  <div className="form-check form-switch mb-0">
                    <input type="checkbox" className="form-check-input" id="omitirCerticamara" checked={omitirCerticamara} onChange={e => setOmitirCerticamara(e.target.checked)} style={{ width: '2.5rem', height: '1.3rem' }} />
                    <label className="form-check-label small fw-bold" htmlFor="omitirCerticamara">{omitirCerticamara ? '🚧 Sin Certicámara' : 'Con Certicámara'}</label>
                  </div>
                </div>
              )}

              <div className="alert alert-success py-2 small">
                <i className="bi bi-shield-check me-2"></i>
                <strong>Sello Digital:</strong> Cuando todos los firmantes completen el proceso, el documento será enviado a Certicámara para su certificación.
              </div>

              <div className="d-flex justify-content-between mt-4">
                <button className="btn btn-outline-secondary" onClick={retroceder}><i className="bi bi-arrow-left me-1"></i> Atrás</button>
                <button className="btn btn-success btn-lg px-5" onClick={handleSubmit} disabled={enviando}>
                  {enviando ? <><span className="spinner-border spinner-border-sm me-2"></span>Enviando...</> : <><i className="bi bi-send me-2"></i>Enviar a {firmantes.length} firmante{firmantes.length > 1 ? 's' : ''}</>}
                </button>
              </div>
            </div>
          </div>
        )}
      </div>

      {enviando && (
        <div style={{ position: 'fixed', inset: 0, backgroundColor: 'rgba(0,0,0,0.7)', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 9999 }}>
          <div className="text-center bg-white p-5 rounded-4 shadow-lg">
            <div className="spinner-border text-success mb-3" style={{ width: '4rem', height: '4rem' }}></div>
            <h5 className="fw-bold">{processingMessage}</h5>
            <p className="text-muted mb-0 small">Por favor espera...</p>
          </div>
        </div>
      )}
    </div>
  );
}

export default AdminSendDocumentPage;